import {
  UPDATE_CAN_RUN_EXTENSION,
  UPDATE_EXTENSION_INSTALLED,
} from '../constants/actions';

export const updateCanRunExtension = canRun => {
  return {
    type: UPDATE_CAN_RUN_EXTENSION,
    canRun,
  };
};

export const updateExtensionInstalled = installed => {
  return {
    type: UPDATE_EXTENSION_INSTALLED,
    installed,
  };
};
